module.exports = __webpack_public_path__ + "media/images/flags/4x3/mdv-baa407ebf21f3da56efae5e313f249f5.svg";